import React from 'react';

const TYPE_STYLES = {
  positive:   { bg: 'bg-[var(--msml-success-bg)]', border: 'border-[var(--msml-success)]/20', text: 'text-[var(--msml-success)]', tag: 'Positive' },
  negative:   { bg: 'bg-[var(--msml-danger-bg)]',  border: 'border-[var(--msml-danger)]/20',  text: 'text-[var(--msml-danger)]',  tag: 'Negative' },
  risk:       { bg: 'bg-[var(--msml-warning-bg)]', border: 'border-[var(--msml-warning)]/20', text: 'text-[var(--msml-warning)]', tag: 'Risk' },
  dependency: { bg: 'bg-[#EC4899]/10',             border: 'border-[#EC4899]/20',             text: 'text-[#EC4899]',             tag: 'Dependency' },
  neutral:    { bg: 'bg-white/5',                   border: 'border-white/10',                 text: 'text-[var(--msml-text-secondary)]', tag: 'Neutral' },
};

export function EvidencePanel({ evidence, activeDimension }) {
  const filtered = activeDimension
    ? evidence.filter(e => e.dimension === activeDimension)
    : evidence;

  if (filtered.length === 0) return null;

  return (
    <div className="msml-card !p-4 !gap-3 msml-slide-up" style={{ animationDelay: '0.15s' }} data-testid="evidence-card">
      <span className="msml-label">Evidence Spans</span>
      <div className="space-y-2 max-h-[240px] overflow-y-auto scrollbar-thin">
        {filtered.map((ev, idx) => {
          const s = TYPE_STYLES[ev.type] || TYPE_STYLES.neutral;
          return (
            <div key={idx} className={`rounded-md border p-2.5 ${s.bg} ${s.border} transition-all duration-200`} data-testid={`evidence-${idx}`}>
              <div className="flex items-center gap-2 mb-1">
                <span className={`text-[10px] font-medium uppercase tracking-wider ${s.text}`}>{s.tag}</span>
                <span className="text-[10px] text-[var(--msml-text-muted)]">{ev.dimensionLabel}</span>
              </div>
              <p className="text-xs text-[var(--msml-text-secondary)] leading-relaxed italic">&ldquo;{ev.quote}&rdquo;</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
